import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { LanguageService, EventBusService } from '@signature-it/ngx-generic/services';
import { EventData, EventName } from '@signature-it/ngx-generic/classes';
import { Observable , EMPTY } from 'rxjs';
import { UtilityService } from './utility.service';
import { EncodeSeoUriPipe } from '@signature-it/ngx-catalogue/pipes';
import { ProductFullSolrDTO} from '@signature-it/ngx-catalogue/models';
import { SolrProductService } from './solr-product.service';
import { ProductType } from '@signature-it/ngx-catalogue/classes';

@Injectable({
	providedIn: 'root'
})
export class ProductPageResolver  {

	constructor(private router: Router,
				private utilitySvc: UtilityService,
				private encodeSeoUri: EncodeSeoUriPipe,
				protected langSvc: LanguageService,
				protected solrProductService: SolrProductService,
                protected eventBusService: EventBusService) {}

	resolve(route: ActivatedRouteSnapshot): Observable <any> {
		const leafName = route.params.leafName;
		if (GenericConfig.disable_friendly_url && leafName) {
			this.router.navigate(['/404']);
		}
		const productId = route.params.id.split('?')[0];
		return new Observable(observer => {
			this.langSvc.getCurrentLanguage$().subscribe(lang => {
				this.getProduct(lang, productId, route, observer, leafName);
			});
		});
	}

    getProduct(lang, productId, route, observer, leafName) {
        const taxonomyVar = route.params.taxonomyVar;
        const leafNodeUri = route.params.leafNodeUri;
        let productPageUrlField = GenericConfig.productPageUrlField ? GenericConfig.productPageUrlField : 'product_id_i';
        if (productPageUrlField == 'product_code_s') {
            this.solrProductService.getSolrByProductCode(productId, lang, taxonomyVar, leafNodeUri).subscribe((solrProduct: ProductFullSolrDTO) => {
                this.navigateToProduct(solrProduct, taxonomyVar, route, observer, leafName, productId);
            }, error => {
                this.router.navigate(['/404']);
                observer.next(EMPTY);
                observer.complete();
            });
        } else {
            this.solrProductService.getSolrByProductId(lang, productId, '', taxonomyVar, leafNodeUri).subscribe((solrProduct: ProductFullSolrDTO) => {
                this.navigateToProduct(solrProduct, taxonomyVar, route, observer, leafName, productId);
            }, error => {
                this.router.navigate(['/404']);
                observer.next(EMPTY);
                observer.complete();
            });
        }
    }

    navigateToProduct(solrProduct, taxonomyVar, route, observer, leafName, productId) {
        if (solrProduct.product_id_i == -1) {
            this.router.navigate(['/404']);
            observer.next(EMPTY);
        } else {
            let type = ProductType.getRoute(solrProduct.productType || ProductType.Product);
            this.eventBusService.emit(new EventData(EventName.DATA_FOR_ANALYTICS_READY, {page: 'product-page', data: solrProduct}));
            if (!taxonomyVar) {
                if (!leafName && !GenericConfig.disable_friendly_url) {
                    const leafGroupName = encodeURIComponent(this.encodeSeoUri.transform(solrProduct.group_slug_s));
                    this.router.navigate([`${leafGroupName}/${type}-page/${productId}`], {queryParams: route.queryParams});
                } else if (leafName && !GenericConfig.disable_friendly_url && route.url[1].path !== `${type}-page`) {
                    this.router.navigate([`${leafName}/${type}-page/${productId}`], {queryParams: route.queryParams});
                } else if (GenericConfig.disable_friendly_url && type !== ProductType.Product && route.url[0].path !== `${type}-page` && route.url[0].path !== `${type}-view-page`) {
                    this.router.navigate([`${type}-page/${productId}`], {queryParams: route.queryParams});
                }
            }
            observer.next(solrProduct);
            observer.complete();
        }
    }
}
